import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  convertObjectToQueryString(obj: any) {
    return Object.entries(obj)
      .filter(([_, v]) => v !== null && v !== undefined)
      .map(([k, v]: any) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
  }

  formatLabel(text: string): string {
    if (!text) return '';
    return text
      .replace(/[_\/]+/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\s+/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase())
      .trim();
  }

  setNullForEmptyvalue(data: any = {}) {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        value === '' ? null : value
      ])
    );
  }

  getErrorMessage(control: any): string {

    if (!control || !control.errors || !control.touched) {
      return '';
    }

    if (control.hasError('required')) {
      return 'This field is required';
    }

    if (control.hasError('minlength')) {
      const requiredLength = control.errors?.['minlength']?.requiredLength;
      return `Minimum length is ${requiredLength}`;
    }

    if (control.hasError('maxlength')) {
      const requiredLength = control.errors?.['maxlength']?.requiredLength;
      return `Maximum length is ${requiredLength}`;
    }

    if (control.hasError('pattern')) {
      return 'Invalid format';
    }

    if (control.hasError('min')) {
      const min = control.errors?.['min']?.min;
      return `Minimum allowed value is ${min}`;
    }

    if (control.hasError('max')) {
      const max = control.errors?.['max']?.max;
      return `Maximum allowed value is ${max}`;
    }

    return 'Invalid value';
  }

  mapToList(
    res: any,
    successKey: 'status' | 'success' = 'status',
    extraFields: string[] = []
  ): any[] {
    const ok = res?.[successKey];
    const data = res?.data;

    if (!ok || !Array.isArray(data)) {
      return [];
    }

    return data.map((item: any) => {
      const mapped: any = {
        label: item.name,
        value: item.id
      };

      extraFields.forEach(field => {
        if (item[field] !== undefined) {
          mapped[field] = item[field];
        }
      });

      return mapped;
    });
  }

}
